import React, { useState } from "react";
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import { HeaderContainer, LogoContainer, LinkContainer, CopyButton } from "./styled";
import SparkleLogo from '../../assets/images/sparklelogo.png';
import { ROUTE_PATH } from "../../constants/routePath";
import { useStore } from "../../hooks/storeContext";
import { Link } from "react-router-dom";

const Header = () => {
    const { authStore } = useStore();
    const fullLink = `https://sparkle.store/${authStore.me.userName}`; // Full URL for the href
    const displayedLink = `sparkle.store/${authStore.me.userName}`; // Displayed link without https://
    const [copied, setCopied] = useState(false); // State to manage copy status

    const handleCopyLink = () => {
        navigator.clipboard.writeText(fullLink); // Copy the full link including https://
        setCopied(true); // Set copied state to true
        setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
    };

    return (
        <HeaderContainer>
            <LogoContainer>
                <Link to={ROUTE_PATH.DASHBOARD}>
                    <img style={{ height: "30px" }} src={SparkleLogo} alt="Sparkle Logo" />
                </Link>
            </LogoContainer>
            <LinkContainer>
                <a style={{ fontSize: '14px', fontWeight: 600 }} href={fullLink} target="_blank" rel="noopener noreferrer">
                    {displayedLink}
                </a>
                <CopyButton
                    onClick={handleCopyLink}
                    style={{ padding: '5px', display: 'flex', alignItems: 'center' }}
                >
                    {copied ? <CheckOutlined style={{ fontSize: '20px', color: 'green' }} /> : <CopyOutlined style={{ fontSize: '20px' }} />}
                </CopyButton>
            </LinkContainer>
        </HeaderContainer>
    );
};

export default Header;
